const shape = {
    borderRadius: {
        small: "6px",
        medium: "12px",
        large: "16px",
    },
};

export default shape;
